import React from 'react';
import { Eye, Hexagon } from 'lucide-react';
import { Button } from '../ui/button';
import { getCategoryColor } from '../../utils/helpers';
import { iconMap } from './helpers';

export const WatchlistTab = ({ watchlist, listings, setBuyModal, toggleWatchlist, setTab, formatCurrency }) => {
  if (watchlist.length === 0) {
    return (
      <div>
        <div className="luxury-card p-12 text-center">
          <Eye size={48} className="text-muted-foreground/30 mx-auto mb-4" />
          <h3 className="text-white font-serif text-xl mb-2">Your Watchlist is Empty</h3>
          <p className="text-muted-foreground text-sm mb-4">Click the eye icon on any listing to track assets you are interested in.</p>
          <Button onClick={() => setTab('browse')} variant="outline" className="border-[#627EEA]/30 text-[#627EEA]">Browse Listings</Button>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {listings.filter(l => watchlist.includes(l.id)).map((item) => {
          const Icon = iconMap[item.category] || Hexagon;
          return (
            <div key={item.id} className="luxury-card p-5" data-testid={`watchlist-${item.id}`}>
              <div className="flex items-center gap-3 mb-3">
                <Icon size={16} className={getCategoryColor(item.category)} />
                <h3 className="text-white font-medium truncate">{item.asset_name}</h3>
              </div>
              <p className="text-gold font-semibold">{formatCurrency(item.price_per_fraction)} / fraction</p>
              <p className="text-xs text-muted-foreground mt-1">{item.fractions_available} fractions available</p>
              <div className="flex gap-2 mt-3">
                <Button onClick={() => setBuyModal(item)} size="sm" className="bg-[#627EEA] hover:bg-[#5570D0] text-white text-xs flex-1">Buy</Button>
                <Button onClick={() => toggleWatchlist(item.id)} size="sm" variant="outline" className="border-red-500/30 text-red-400 hover:bg-red-500/10 text-xs">Remove</Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
